import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const LabelKindThumb = hoc(
    (props: IconProps) => (
        <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <circle cx={8} cy={8} r={8} fill="#4BB24E" />
            <path
                d="M5.91671 12.1667H4.66671C4.44569 12.1667 4.23373 12.0789 4.07745 11.9226C3.92117 11.7663 3.83337 11.5544 3.83337 11.3334V8.41671C3.83337 8.19569 3.92117 7.98373 4.07745 7.82745C4.23373 7.67117 4.44569 7.58337 4.66671 7.58337H5.91671M8.83337 6.75004V5.08337C8.83337 4.75185 8.70168 4.43391 8.46726 4.19949C8.23284 3.96507 7.91489 3.83337 7.58337 3.83337L5.91671 7.58337V12.1667H10.6167C10.8177 12.169 11.0127 12.0985 11.1658 11.9684C11.319 11.8382 11.4199 11.6571 11.45 11.4584L12.025 7.70837C12.0432 7.58894 12.0351 7.46699 12.0014 7.35098C11.9678 7.23497 11.9092 7.12766 11.83 7.0365C11.7507 6.94535 11.6526 6.87251 11.5424 6.82305C11.4322 6.77358 11.3125 6.74867 11.1917 6.75004H8.83337Z"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    'Label'
);
export default LabelKindThumb;
